import { c as _c } from "react/compiler-runtime";
import React from 'react';
const DoubleCircleIcon = t0 => {
  const $ = _c(9);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      selected: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const selected = t1 === undefined ? false : t1;
  let t2;
  if ($[3] !== selected) {
    t2 = selected && <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" />;
    $[3] = selected;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <circle cx="10" cy="10" r="5" fill="currentColor" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t2) {
    t4 = <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>{t2}{t3}</svg>;
    $[6] = props;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default DoubleCircleIcon;